/**
 * Created by Jie Gao on 2018-11-06.
 */
import {
    ITextBetLineNumberConfig,
    TextBetLineNumber
} from "@nolimitcity/slot-game/bin/game/betline/number/TextBetLineNumber";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";

export function isNumber(value:any):value is number {
    return typeof value === "number" && value === value;
}

export class StarStruckBetlineNumber extends TextBetLineNumber{

    private readonly POSITIONS_Y:number[] = [146, 340,196,  484, 533,146, 340,196,  484, 533];
    private _ssHorizontalPadding:[number, number];
    private _ssVerticalPadding:[number, number];
    constructor(index:number, config:ITextBetLineNumberConfig) {
        super(index, config);
        if(isNumber(config.horizontalPadding)) {
            this._ssHorizontalPadding = [config.horizontalPadding, config.horizontalPadding];
        } else {
            this._ssHorizontalPadding = config.horizontalPadding;
        }
        if(isNumber(config.verticalPadding)) {
            this._ssVerticalPadding = [config.verticalPadding, config.verticalPadding];
        } else {
            this._ssVerticalPadding = config.verticalPadding;
        }
    }

    protected draw(config:ITextBetLineNumberConfig):void {
        const background:PIXI.Graphics = new PIXI.Graphics();
        background.beginFill(0x000000, 0);
        background.drawRect(-config.width/2, -config.height/2, config.width, config.height);
        background.endFill();
        this.addChild(background);
        StageManager.getLayer(config.layer).addChild(this);
    }

    protected showMouseOver():void {}

    protected showMouseOut():void {}

    protected showWin():void {}

    protected showNormal():void {}

    public setPosition(betLinesNum:number, positionIndex:number):number[] {
        const stageWidth:number = GameConfig.instance.GAME_WIDTH;
        const numLineInOneSide:number = betLinesNum / 2;
        const numberLeftPositionX:number = this._ssHorizontalPadding[0];
        const numberRightPositionX:number = stageWidth - this._ssHorizontalPadding[1] + 4;

        const side:number = Math.floor(positionIndex / numLineInOneSide);
        const x:number = side === 0 ? numberLeftPositionX : numberRightPositionX;
        const y:number = this.POSITIONS_Y[positionIndex];
        this.x = x;
        this.y = y;
        this.alpha = 1;

        return [x, y, side];
    }
}